<template>

  <t-page>

    <t-page-form tabs :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <t-form-tab title="Dados Básicos" active>

        <t-input v-model="form.priceListId" hidden/>

        <t-input v-model="form.name" :add-error="error.name" label="Tabela de Preços" required/>

        <!--
        <b-form-checkbox class="col-sm-12 ml-2 mb-3" v-model="form.enableAllCompanies" switch>
          Habilitar todas empresas a esta tabela de preços?
          <t-help
              title="Você poderá especificar quais as empresas desejadas, basta desmarcar esta opção e especificar quais as empresas abaixo."/>
        </b-form-checkbox>
        -->

        <t-input
            v-if="!form.enableAllCompanies"
            v-model="form.companyId"
            @change="onCompanyResume"
            :options="companyOptions" first-default :required="!form.enableAllCompanies" label="Empresa" select/>


        <!--        <t-table
                    v-if="!form.enableAllCompanies"
                    enable-checked
                    v-model="companiesIds"
                    :items="companiesList"
                    :fields="viewFieldsPageCompanies"
                    title-items="empresa"
                    link-primary-column="name"
                    class="mb-2"
                    table-bordered
                    disable-actions-column
                    primary-key-column="companyId">

                  <template #first-column="{item}">
                    {{ item.name }}
                  </template>

                </t-table>-->

        <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

        <t-input-status v-model="form.status" class="mb-2"/>

      </t-form-tab>

      <!--DESABILITADO EM 06/02/2025 POIS NÃO POSSUI APLICAÇÃO PRÁTICA NO MOMENTO    -->
      <!--      <t-form-tab title="Anomalias" hash="pathology">

              <t-table
                  :items="pathologiesList"
                  :fields="viewFieldsPagePathologies"
                  enable-search
                  :disable-search="['price','unit','sector']"
                  title-items="anomalias"
                  class="mb-2"
                  table-bordered
                  disable-actions-column
                  primary-key-column="typePathologyId">

                <template #first-column="{item}">
                  {{ item.name }}
                </template>

                <template #item(price)="{item}">

                  <t-input v-model="item.price" highlight hide-label number decimals="2"/>

                </template>

              </t-table>

            </t-form-tab>-->

      <t-form-tab title="Itens" hash="items">

        <t-table
            :items="typeChecklistItemList"
            :fields="viewFieldsPageTypeChecklistItems"
            enable-pagination
            :disable-search="['unitOtherExpense','defaultInvoiceTax','defaultCompanyExpense']"
            enable-search
            title-items="itens"
            class="mb-2"
            table-bordered
            table-striped
            disable-actions-column
            primary-key-column="typeChecklistItemId">

          <template #first-column="{item}">
            {{ item.name }} <span v-if="item.unit !== ''">({{ item.unit }})</span>
          </template>

          <template #item(unitPrice)="{item}">

            <t-input v-model="item.unitPrice" @focusout="forceUpdateList" placeholder="R$ Venda" highlight hide-label money/>

          </template>

          <template #item(unitCostLabor)="{item}">

            <t-input v-model="item.unitCostLabor" @focusout="forceUpdateList" placeholder="R$ Mão de Obra" hide-label money/>

          </template>

          <template #item(unitCostMaterial)="{item}">

            <t-input v-model="item.unitCostMaterial" @focusout="forceUpdateList" placeholder="R$ Material" hide-label money/>

          </template>

          <template #item(unitOtherExpense)="{item}">

            <div v-show="item.unitOtherExpense > 0 || item.detailOtherExpense">
              <t-input v-model="item.unitOtherExpense" @focusout="forceUpdateList" placeholder="% BDI" hide-label
                       percent/>
              <b-link @click="detailOtherExpense(item,false)">Retornar Padrão</b-link>

            </div>

            <div v-show="item.unitOtherExpense === 0">
              <div>{{ defaultCompanyExpense.defaultOtherExpense | percent }}</div>
              <b-link @click="detailOtherExpense(item,true)">Especificar</b-link>
            </div>

          </template>

          <template #item(defaultInvoiceTax)>

            <div>{{ defaultCompanyExpense.defaultInvoiceTax | percent }}</div>

          </template>

          <template #item(defaultCompanyExpense)>

            <div>{{ defaultCompanyExpense.defaultCompanyExpense | percent }}</div>

          </template>

        </t-table>

      </t-form-tab>


    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageViewService from "@/services/modules/setting/PageView.service";
import CompanyService from "@/services/modules/admin/Company.service";
/*import TypePathologyService from "@/services/modules/checklist/TypePathology.service";*/
import TypeChecklistItemService from "@/services/modules/checklist/TypeChecklistItem.service";


export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'PriceListForm',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      fieldKey: "priceListId",
      form: {
        priceListId: 0,
        companyId: 0,
        name: "",
        note: "",
        enableAllCompanies: false,
        status: 1,
        /*companies: [],DESABILITADO MULTI EMPRESA*/
        pathologies: [],
        checklistItems: [],
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: ""
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      defaultCompanyExpense: {
        defaultCompanyExpense: 0,
        defaultOtherExpense: 0,
        defaultInvoiceTax: 0,
        name: "",
      },
      companyOptions: [],
      /*
      DESABILITADO MULTI EMPRESA
      companiesIds: [],
      companiesList: [],
      viewFieldsPageCompanies: [],*/
      pathologiesList: [],
      viewFieldsPagePathologies: [
        {
          key: "name",
          label: "Anomalia"
        },
        {
          key: "sector",
          label: "Categoria"
        },
        {
          key: "unit",
          label: "Medida"
        },
        {
          key: "price",
          label: "Valor Un. Padrão",
          formatter: "money",
        }
      ],
      typeChecklistItemList: [],
      viewFieldsPageTypeChecklistItems: [
        {
          key: "name",
          label: "Item",
        },
        {
          key: "unitPrice",
          label: "Preço Un.",
          formatter: "money",
          search: 0.0,
        },
        {
          key: "unitCostLabor",
          label: "MO Un.",
          formatter: "money",
          search: 0.0,
        },
        {
          key: "unitCostMaterial",
          label: "Mat. Un.",
          formatter: "money",
          search: 0.0,
        },
        {
          key: "unitOtherExpense",
          label: "BDI",
          formatter: "percent",
          help: "Caso desejar especificar um BDI (Despesas Indiretas %) por Item o percentual inserido na empresa será ignorado no momento da aplicação no Orçamento, pois este tem maior prioridade."
        },
        {
          key: "defaultInvoiceTax",
          label: "NF",
          formatter: "percent",
          help: "Caso desejar especificar utilize o cadastro de empresas."
        },

        {
          key: "defaultCompanyExpense",
          label: "Outros",
          formatter: "percent",
          help: "Caso desejar especificar utilize o cadastro de empresas."
        },

      ],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    forceUpdateList(){

      let list = []

      for (let item of this.typeChecklistItemList) {
        list.push(item)
      }

      this.typeChecklistItemList = list

    },

    mountedPrepare() {

    },
    async mountedContinued() {

      await pageViewService.getViewFieldsByPage(31, true, [""]).then((response) => {
        this.viewFieldsPageCompanies = response
      }).catch(error => this.responseError(error))

      await CompanyService.selectList("").then((list) => {
        this.companyOptions = list
      }).catch(error => this.responseError(error))

      /*
       DESABILITADO MULTI EMPRESA
       await CompanyService.getAllCompanies().then((list) => {
         this.companiesList = list
         this.companiesIds = this.convertObjectToArrayIds(this.form.companies, "companyId")
       }).catch(error => this.responseError(error))*/

      /*await TypePathologyService.getAllPathologies().then((list) => {

        this.pathologiesList = list

        for (let item of this.pathologiesList) {

          const pathology = this.form.pathologies.find(a => a.typePathologyId === item.typePathologyId)

          item.price = 0

          if (pathology) {
            item.price = pathology.price
          }

        }


      }).catch(error => this.responseError(error))*/

      await TypeChecklistItemService.getAllItemsOrderName().then((list) => {

        this.typeChecklistItemList = list

        for (let item of list) {

          const typeChecklistItem = this.form.checklistItems.find(a => a.typeChecklistItemId === item.typeChecklistItemId)

          item.unitPrice = 0
          item.unitCostMaterial = 0
          item.unitCostLabor = 0
          item.unitOtherExpense = 0

          if (typeChecklistItem) {
            item.unitPrice = typeChecklistItem.unitPrice
            item.unitCostMaterial = typeChecklistItem.unitCostMaterial
            item.unitCostLabor = typeChecklistItem.unitCostLabor
            item.unitOtherExpense = typeChecklistItem.unitOtherExpense
          }

        }


      }).catch(error => this.responseError(error))


      await this.onCompanyResume()


    },
    async onSubmit() {

      //DESABILITADO MULTI EMPRESA EM 13/03/2025
      //this.form.companies = this.convertArrayIdsToObject(this.companiesIds, "companyId")


      /* this.form.pathologies = []
       for (let item of this.pathologiesList) {

         const pathology = {
           typePathologyId: item.typePathologyId,
           price: item.price
         }

         this.form.pathologies.push(pathology)
       }*/

      this.form.checklistItems = []
      for (let item of this.typeChecklistItemList) {

        const typeChecklistItem = {
          typeChecklistItemId: item.typeChecklistItemId,
          unitPrice: item.unitPrice,
          unitCostMaterial: item.unitCostMaterial,
          unitCostLabor: item.unitCostLabor,
          unitOtherExpense: item.unitOtherExpense,
        }

        this.form.checklistItems.push(typeChecklistItem)
      }

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    async onCompanyResume() {

      if (this.form.companyId > 0) {

        await CompanyService.getResume(this.form.companyId).then(resume => {

          this.defaultCompanyExpense = resume.data

        }).catch(error => this.responseError(error))

      }

    },

    detailOtherExpense(item,enable){

      if(enable){
        //Coloca o percentual da empresa por padrão
        item.detailOtherExpense = true
        item.unitOtherExpense = this.defaultCompanyExpense.defaultOtherExpense
      }else{
        item.detailOtherExpense = false
        item.unitOtherExpense = 0
      }

      this.$forceUpdate();

    }
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm()

    await this.mountedContinued()

  },

}
</script>
